export function getAll() {
  return [
    {
      value: 0,
      name: "Year",
      text: "年",
    },
    {
      value: 1,
      name: "Month",
      text: "月",
    },
    {
      value: 2,
      name: "Day",
      text: "日",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
